// import { Interceptor } from "./interceptor";

import {
  serializeQueryParams,
  checkStatus,
  createRequest,
  isKFDomain
} from "./utils.js";
import { Queue } from "./queue.js";
import { BaseService } from "./base.service.js";

let abortRequestList = {};

export const cancelDataServiceRequestByKey = (key) => {
  const pendingComponentAbortList = abortRequestList[key];
  if (pendingComponentAbortList) {
    pendingComponentAbortList.map((data) => data.abort());
    //clearing fetch list for that key
    abortRequestList[key] = [];
  }
};

class DataService extends BaseService {
  sendRequest(url, options) {
    let controller = new AbortController();
    options.signal = controller.signal;

    if (
      options.hasOwnProperty("cancelPendingRequestkey") &&
      options.cancelPendingRequestkey
    ) {
      abortRequestList[options.cancelPendingRequestkey] = abortRequestList[
        options.cancelPendingRequestkey
      ]
        ? [...abortRequestList[options.cancelPendingRequestkey], controller]
        : [controller];
    }

    let promise = async function gettingRequest() {
      let request = await createRequest(url, options);
      return this.interceptor.fetch(request).catch((err) => {
        this._sendErrorToast(options, err);
        return Promise.reject(err);
      });
    };

    return [promise.bind(this), () => controller.abort()];
  }

  postq(url, options = {}, callback = () => false, queueName = "default") {
    let queue = Queue.getQueue(queueName, this.sendRequest.bind(this));
    options.method = "POST";
    return queue.queueRequest(url, options, callback);
  }

  fetch(url, options = {}) {
    const controller = new AbortController();
    options = Object.assign(
      { method: "GET", signal: controller.signal },
      options
    );

    const promise = async function gettingRequest() {
      const request = await createRequest(url, options);
      return fetch(request)
        .then(checkStatus)
        .catch((err) => {
          this._sendErrorToast(options, err);
          return Promise.reject(err);
        });
    };
    return [promise.bind(this), () => controller.abort()];
  }

  upload(url, options = {}) {
    if (options.query) {
      url = serializeQueryParams(url, options.query);
    }
    if (isKFDomain(url)) {
      options.headers["X-Csrf-Token"] = window.accountDetails?.AuthToken;
    }
    return fetch(url, options)
      .then(checkStatus)
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  xhrRequest(url) {
    // new rqeuest
    let req = new XMLHttpRequest();
    req.open("GET", url, true);
    //crsf token
    const { AuthToken } = window.accountDetails;
    if (AuthToken) {
      req.setRequestHeader("X-Csrf-Token", AuthToken);
    }
    req.responseType = "blob";
    req.send();
    return req;
  }
}

const DATA_SERVICE_INSTANCE = new DataService();
export { DATA_SERVICE_INSTANCE as DataService };

/**
 * Interface:
 *
 * let [apiCall, cancelSignal] = DataService.get("url", {data: payload})
 * apiCall().then(data => {...})
 * onUnmount(() => cancelSignal());
 */
